<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
          &copy; 2017 - Philip Elliott: PHP/Web Developer from Leeds, UK.
        </p>
        <p>
          <a href="https://www.linkedin.com/in/philipsimonelliott/">
            <span class="icon">
              <i class="fa fa-linkedin"></i>
            </span>
          </a>
          <a href="https://github.com/fyllepo" target="_blank">
            <span class="icon">
              <i class="fa fa-github"></i>
            </span>
          </a>
        </p>
      </div>
    </div>
  </footer> 
</template>

<script>
  export default {
    name: 'page-footer'
  }
</script>



// WEBPACK FOOTER //
// src/components/PageFooter.vue